"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkSendAccess = exports.checkAccountAccess = void 0;
const user_1 = require("../models/user");
function checkAccountAccess(user, userPermissions, emailAccount) {
    return ((0, user_1.hasRole)(userPermissions, 'site_owner') ||
        emailAccount.publicAccess ||
        ((0, user_1.hasRole)(userPermissions, 'email_account_admin') && !emailAccount.email.match(/@getrocket.com$/)) ||
        emailAccount.owners.includes(user.id));
}
exports.checkAccountAccess = checkAccountAccess;
function checkSendAccess(user, userPermissions, emailAccount, data) {
    if (emailAccount.syncStatus !== 'enabled') {
        return false;
    }
    const hasAccountAccess = checkAccountAccess(user, userPermissions, emailAccount);
    if (hasAccountAccess) {
        return true;
    }
    const { jobs, personsCandidates } = data;
    // Allow AM
    if (jobs.find((j) => j.accountManagerId === user.id)) {
        return true;
    }
    // Allow candidate assignee
    if (personsCandidates.find((c) => c.assignee === user.id)) {
        return true;
    }
    // Allow Job assignee
    if (jobs.find((j) => j.assignee === user.id)) {
        return true;
    }
    return false;
}
exports.checkSendAccess = checkSendAccess;
//# sourceMappingURL=email-access.js.map